import React from 'react'
import './Sec8Role.css'

function Sec8Role() {
  return (
    <div className='Sec8Role container'>
      {/* <h3 className='Sec8Role-title'> That’s what this report unpacks.</h3> */}
      <p className='Sec8Role-para text'> “<b>India’s GCC Leap: Powering Global Mid-Market Momentum,</b>” dives into the data and decisions shaping this movement, from talent density and tech depth to agile operating models and the rise of city-level ecosystems.</p>
    </div>
  )
}

export default Sec8Role
